// extracted by mini-css-extract-plugin
export default {"card":"MetricCard_card__V0U5q","label":"MetricCard_label__HTucg","value":"MetricCard_value__vDCZM","sub":"MetricCard_sub__fA-iH"};